import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchSpeakersPage } from '@/store/slices/speakers';
import { selectSpeakerState } from '@/store/slices/speakers/selectors';
import { getActiveChannel } from '@/store/slices/user/selectors';

type TUseLoadSpeakers = {
  skipIfSpeakersExist?: boolean;
};

const useLoadSpeakers = (props?: TUseLoadSpeakers) => {
  const { skipIfSpeakersExist } = props || {};

  const channel = useAppSelector(getActiveChannel);
  const speakers = useAppSelector(selectSpeakerState);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  useEffect(() => {
    if (!channel || fetched.current) return;
    if (skipIfSpeakersExist && speakers.ids.length) return;

    fetched.current = true;
    dispatch(fetchSpeakersPage({ channel, page: 1 }));
  }, [speakers.ids.length, channel, dispatch, skipIfSpeakersExist]);
};

export default useLoadSpeakers;
